import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import Logo from '../../assets/img/logo.svg'

import authRep from '../../repository/authRep'
import { sendNotify, fetchApi } from '../../helper'
import { checkLogged } from '../../store/auth/authSlice'

export default function Login() {
  const dispatch = useDispatch()

  const [togglePass, setTogglePass] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const login = () => {
    let payload = {};
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (email && filter.test(email) && password) {
      setLoading(true)
      payload['email'] = email
      payload['password'] = password
      authRep.login(payload).then(response => {
        if (response) {
          setLoading(false)
          if (response.error) {
            sendNotify('error', response.error?.response?.data?.message)
          } else {
            if (response?.data) {
              sendNotify('success', 'Login successfully')
              localStorage.setItem(process.env.REACT_APP_JWT_TOKEN, JSON.stringify(response?.data))
              dispatch(checkLogged())
            } else {
              sendNotify('error', 'Unauthorized Account')
            }
          }
        }
      })
        .catch(error => ({ error: JSON.stringify(error) }));

    } else {
      if (email == '') {
        sendNotify('error', 'Give your email')
      } else {
        if (!filter.test(email)) {
          sendNotify('error', 'Please provide a valid email')
        }
      }
      if (password == '') {
        sendNotify('error', 'Give your password')
      }
    }
  }

  return (
    <div className='auth-form'>
      <img src={Logo} className='logo' alt="NL - Sendinel" />
      <h2>Login</h2>
      <div className="input-box">
        <label htmlFor="email">Email</label>
        <div className='input-field'>
          <input type="email" name='email' id='email' onChange={(e) => setEmail(e.target.value)} placeholder='Enter your email address' onKeyPress={(e) => e.key === 'Enter' && login()} />
        </div>
      </div>
      <div className="input-box">
        <label htmlFor="password">Password</label>
        <div className='input-field'>
          <input type={togglePass ? 'text' : 'password'} name='password' id='password' onChange={(e) => setPassword(e.target.value)} placeholder='Enter your password' onKeyPress={(e) => e.key === 'Enter' && login()} />
          <button className='input-after color-primary' onClick={() => setTogglePass(!togglePass)}>
            <i className={`far ${togglePass ? 'fa-eye-slash' : 'fa-eye'}`}></i>
          </button>
        </div>
      </div>
      <button className={`primary-btn mx-auto ${loading ? 'btn-loading' : ''}`} onClick={login}>Login
        <i className={`far ${loading ? 'fa-spinner-third' : 'fa-sign-in'} ms-2 me-0`}></i>
      </button>
      <p className='auth-footer'>Don't have an account <Link to={'/register'}>register here.</Link></p>
    </div>
  )
}
